import { useMemo } from "react";
import { useShallow } from "zustand/react/shallow";

import Icon from "ds/components/Icon";
import SegmentedControl, { SegmentedControlOption } from "ds/components/SegmentedControl";

import useAvailableChatModes from "../hooks/useAvailableChatModes";
import { CHAT_MODES } from "./constants";
import useChatStore from "../store/useStore";
import { ChatMode } from "../types";
import styles from "./styles.module.css";

const ChatModeSwitcher = () => {
  const { buildModeEnabled } = useAvailableChatModes();
  const { mode, setMode } = useChatStore(
    useShallow((state) => ({
      mode: state.mode,
      setMode: state.setMode,
    }))
  );

  const options = useMemo<SegmentedControlOption<ChatMode>[]>(
    () => [
      {
        label: (
          <>
            <Icon src={CHAT_MODES[ChatMode.ASK].icon} noShrink />
            {CHAT_MODES[ChatMode.ASK].label}
          </>
        ),
        value: ChatMode.ASK,
        tooltip: CHAT_MODES[ChatMode.ASK].tooltip,
      },
      {
        label: (
          <>
            <Icon src={CHAT_MODES[ChatMode.BUILD].icon} noShrink />
            {CHAT_MODES[ChatMode.BUILD].label}
          </>
        ),
        value: ChatMode.BUILD,
        disabled: !buildModeEnabled,
        tooltip: buildModeEnabled
          ? CHAT_MODES[ChatMode.BUILD].tooltip
          : "Build mode is not enabled. An admin can enable it in Spacelift Intelligence settings.",
      },
    ],
    [buildModeEnabled]
  );

  return (
    <SegmentedControl
      options={options}
      value={mode}
      onChange={setMode}
      size="small"
      optionClassName={styles.option}
    />
  );
};

export default ChatModeSwitcher;
